<template>
  <div class="main">
    <h2 class="is-print-hide title-area">
      <span class="main-title">
        <el-button @click="$router.back()" type="text"><span class="font22">登记记录</span></el-button>
        <span>>登记详情</span>
      </span>
    </h2>
    <el-card>
      <div class="box">
        <div class="item">
          <span class="key">登记单号：</span>
          <span class="key">{{ detail.registrationId }}</span>
        </div>
        <div class="item">
          <span class="key">登记时间：</span>
          <span class="key">{{ detail.registrationTime | formatTime }}</span>
        </div>
      </div>
      <div>
        <div class="title">用药人实名信息</div>
        <div class="box">
          <div class="item">
            <span class="key">姓名：</span>
            <span class="value">{{ detail.userName }}</span>
          </div>
          <div class="item">
            <span class="key">身份证号：</span>
            <span class="value">{{ detail.idcardNo }}</span>
          </div>
          <div class="item">
            <span class="key">手机号码：</span>
            <span class="value">{{ detail.userPhone }}</span>
          </div>
        </div>
        <div class="box">
          <div class="item">
            <span class="key">性别：</span>
            <span class="value">{{ detail.sex | userSex }}</span>
          </div>
          <div class="item">
            <span class="key">年龄：</span>
            <span class="value">{{ detail.age }}</span>
          </div>
          <div class="item"></div>
        </div>
      </div>
      <div>
        <div>
          <div class="title">药品信息</div>
          <div v-for="(item, key) in detail.drugDetailResponse" :key="key">
            <div style="margin-bottom: 20px">
              <div class="box">
                <div class="item">
                  <span class="key">药品名：</span>
                  <span class="value">{{ item.drugName }}</span>
                </div>
                <div class="item">
                  <span class="key">规格：</span>
                  <span class="value">{{ item.drugSpec }}</span>
                </div>
                <div class="item">
                  <span class="key">数量：</span>
                  <span class="value">{{ item.drugNum }}</span>
                </div>
              </div>
              <div class="box">
                <div class="item">
                  <span class="key">生产厂家：</span>
                  <span class="value">{{ item.drugManufacturer }}</span>
                </div>
                <div class="item">
                  <span class="key">生产批号：</span>
                  <span class="value">{{ item.drugProductBatchNo }}</span>
                </div>
                <div class="item">
                  <span class="key">有效期至：</span>
                  <span class="value">{{ item.drugValidityPeriod | formatTime('day') }}</span>
                </div>
              </div>

              <!-- <span class="key">{{ item.drugName + ' ' }}</span>
              <span class="key">{{ item.drugNum }}</span> -->
            </div>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import dayjs from 'dayjs';
export default {
  data() {
    return {
      id: this.$route.query.id || null,
      detail: {}
    };
  },
  filters: {
    formatTime(val, day) {
      if (!val) return '--';
      if (day) {
        return dayjs(val).format('YYYY年MM月DD日');
      }
      return dayjs(val).format('YYYY-MM-DD HH:mm:ss');
    },
    status(val) {
      return { 0: '否', 1: '是' }[val];
    },
    userSex(val) {
      return { 0: '女', 1: '男' }[val];
    },
    purchasePurposeStatus(val) {
      return { 0: '本人自用', 1: '备用', 2: '他人使用' }[val] || '--';
    }
  },
  computed: {
    ...mapGetters(['storeList']),
    storeId() {
      const { storeList } = this;
      return Array.isArray(storeList) ? storeList?.[0].id : storeList?.id;
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const { storeId, id } = this;
      return Fetch.getSupervisionIvDetail({
        registrationId: id || null,
        storeId,
        registrationType: 1
      }).then(res => {
        this.detail = res || {};
      });
    }
  }
};
</script>
<style scoped>
.font22 {
  font-size: 22px;
  position: relative;
  top: -1px;
}
.box {
  display: flex;
  justify-content: space-between;
}
.title {
  color: #242424;
  font-size: 20px;
  font-weight: 500;
  line-height: 56px;
}
.item {
  width: 30%;
  text-align: left;
  display: block;
}
.key {
  color: #242424;
  font-size: 14px;
  line-height: 40px;
}
.value {
  color: #666;
  font-size: 14px;
  line-height: 40px;
}
</style>
